import { io } from 'socket.io-client';
import api from './api';

// El servidor de Socket.IO vive en el mismo origen que la API
const API_ORIGIN = (api.defaults.baseURL || '').replace(/\/origin\/api\/?$/, '');

export function createSocket() {
  return io(API_ORIGIN, {
    // Debe coincidir con el path del servidor (backend/helpers/socket.js)
    path: '/origin/socket.io',
    auth: (cb) => cb({ token: localStorage.getItem('origenes_token') }),
    transports: ['polling', 'websocket'],
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });
}
